import { effect, inject, Injectable, signal } from '@angular/core';
import { ToastMessageService } from './toast-message.service';
import { ApplicationTimeoutModal } from '../components/application-timeout-modal/application-timeout-modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from './auth.service';
import { ModalService } from './modal.service';
import { StorageNames } from '../constants/storage';
import { firstValueFrom } from 'rxjs';
import { NetworkService } from './network-service.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationSessionService {
  constructor(private mnodalService: ModalService, private auth: AuthService) {
    this.logToConsole = (sessionStorage.getItem('logToConsole') === 'true');
  }

  readonly networkService = inject(NetworkService);
  readonly onLineChange = effect(() => {
    if (environment.pwa) {
      if (this.networkService.isOffline()) {
        this.stop();
      }
      else {
        if (this.started) {
          this.start();
        }
      }
    }
  });

  toast = inject(ToastMessageService);
  timeoutInterval: any;
  tokenRefreshInterval: any;
  started = false;
  start() {
    this.started = true;
    this.appTimeoutStart();
    this.tokenRefreshStart();
  }

  private logToConsole = false;

  private tokenRefreshStart() {
    this.tokenRefreshInterval = setInterval(async () => {
      const expires = new Date(localStorage.getItem(StorageNames.Expires)!).getTime();
      const timeToExpiration = expires - new Date().getTime();
      if (this.logToConsole) {
        console.log(`Checking token expiration for refresh... Expires in ${timeToExpiration / 1000} seconds.`);
      }
      if (timeToExpiration < 60000) {
        this.auth.refreshToken();
      }

    }, 30000);
  }

  private tokenRefreshStop() {
    if (this.timeoutInterval) {
      clearInterval(this.timeoutInterval);
    }
  }

  private appTimeoutStart() {
    this.lastActivitiy = Date();
    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('keyup', this.onKeyUp);

    const appTimeout = +new Number(localStorage.getItem(StorageNames.ExpiresIn));

    const warningInterval = 60;
    const appWarning = appTimeout - warningInterval;

    this.timeoutInterval = setInterval(async () => {
      const timeElapsed = new Date().getTime() - new Date(this.lastActivitiy).getTime();
      if (this.logToConsole) {
        console.log(`Checking inactivity timeout... Last activity at ${this.lastActivitiy}. Timeout is set to ${appTimeout} seconds. Time ellapsed ${timeElapsed / 1000} seconds.`);
      }
      if (timeElapsed > appWarning * 1000) {
        this.appTimeoutStop();
        const modalRef = this.mnodalService.open(ApplicationTimeoutModal, undefined, state => {
          state.timeLeft.set(warningInterval);
        });

        if (!await modalRef.result) {
          this.stop();
          this.auth.logout();
          return;
        }

        this.appTimeoutStart();
      }
    }, 1000);

  }


  private appTimeoutStop() {
    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('keyup', this.onKeyUp);
    if (this.timeoutInterval) {
      clearInterval(this.timeoutInterval);
    }
    this.lastActivitiy = Date()

  }
  stop() {
    this.appTimeoutStop();
    this.tokenRefreshStop();
  }
  private lastActivitiy = Date();
  onMouseMove = (event: MouseEvent) => {
    this.lastActivitiy = Date();
  };

  onKeyDown = (event: KeyboardEvent) => {
    this.lastActivitiy = Date();
  };

  onKeyUp = (event: KeyboardEvent) => {
    this.lastActivitiy = Date();
  };
}
